var map = {
	"./apple.glb": "3d37",
	"./banana.glb": "32c0",
	"./cherry.glb": "6924",
	"./grapes.glb": "a9fc2",
	"./lemon.glb": "b402",
	"./orange.glb": "54b7",
	"./pear.glb": "af78",
	"./pineapple.glb": "9959",
	"./strawberry.glb": "ffa0",
	"./tomato.glb": "86ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c43";